<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"   style="width:400px;margin:auto;" @close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px"  v-loading="loading" :element-loading-text="elementLoadingText">
        <el-row>       
            <div class="el-form-item is-required">
              <label for="invoiceType" class="el-form-item__label" style="width: 100px;">发票类型：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                   <select v-model="form.invoiceType"  class="invoiceType">
                    <option label="普通发票-电子" value="0"></option>
                   </select>
                </div>
              </div>
            </div>
            <div class="el-form-item is-required">
              <label for="invoiceHeaderType" class="el-form-item__label" style="width: 100px;">抬头类型：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <el-radio v-model="invoiceHeaderType" label="个人或者事业单位">个人或者事业单位</el-radio>
                  <el-radio v-model="invoiceHeaderType" label="企业">企业</el-radio>
                </div>
              </div>
            </div>
            <div class="el-form-item is-required">
              <label for="invoiceHeader" class="el-form-item__label" style="width: 100px;">发票抬头：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.invoiceHeader" autocomplete="off" class="el-input__inner" placeholder="填写需要开具发票的姓名">   
                </div>
              </div>
            </div>
            <div v-if="invoiceHeaderType=='企业'" class="el-form-item is-required">
              <label for="dutyParagraph" class="el-form-item__label" style="width: 100px;">税号：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.dutyParagraph" autocomplete="off" class="el-input__inner" placeholder="请填写纳税人识别号">   
                </div>
              </div>
            </div>          
            <div v-if="invoiceHeaderType=='企业'" class="el-form-item">
              <label for="bankName" class="el-form-item__label" style="width: 100px;">开户银行：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.bankName" autocomplete="off" class="el-input__inner" placeholder="选填">   
                </div>
              </div>
            </div>
            <div v-if="invoiceHeaderType=='企业'" class="el-form-item">
              <label for="bankCardNo" class="el-form-item__label" style="width: 100px;">银行账号：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.bankCardNo" autocomplete="off" class="el-input__inner" placeholder="选填">   
                </div>
              </div>
            </div>
            <div v-if="invoiceHeaderType=='企业'" class="el-form-item">
              <label for="companyAddress" class="el-form-item__label" style="width: 100px;">企业地址：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.companyAddress" autocomplete="off" class="el-input__inner" placeholder="选填">   
                </div>
              </div>
            </div>
            <div v-if="invoiceHeaderType=='企业'" class="el-form-item">
              <label for="companyMobile" class="el-form-item__label" style="width: 100px;">企业电话：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <input type="text" v-model="form.companyMobile" autocomplete="off" class="el-input__inner" placeholder="选填">   
                </div>
              </div>
            </div>
            <div class="el-form-item">
              <label for="invoiceHeader" class="el-form-item__label" style="width: 100px;">发票内容：</label>
              <div class="el-form-item__content" style="margin-left: 100px;">
                <div class="el-input">
                  <el-checkbox v-model="form.isInvoiceDetails">明细</el-checkbox>
                </div>
              </div>
            </div>       
        </el-row>   
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="closeBtn"  @click="close">取 消</el-button>
      <el-button class="saveBtn" type="primary" @click="validateData">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createOrEdit, getInvoice } from '@/api/invoice'
export default {
  name: 'EditInvoice',
  components: {  },
  data() {
    return {     
      form: { 
        id:0,
        invoiceType:0,
        invoiceHeaderType:0,
        invoiceHeader:'',
        dutyParagraph:'',
        bankName:'',
        bankCardNo:'',
        companyAddress:'',
        companyMobile:'',
        isInvoiceDetails:false,
      },
      rules: { },  
      codeUrl:'',
      title: '',
      dialogFormVisible: false,
      loading:false,
      elementLoadingText:"数据提交中,请稍后...",     
      invoiceHeaderType:'个人或者事业单位',   
    }
  },
  methods: {
    async show(row) {  
      this.title = '添加发票模板'   
      if(row)
      {
        this.title = '编辑发票模板'  
        await getInvoice({id:row.id}).then(res=>{
            this.form = res.data.result;
            switch(this.form.invoiceHeaderType)
            {
              case 0: this.invoiceHeaderType = '个人或者事业单位';break;
              case 1: this.invoiceHeaderType = '企业';break;
            }
        });
      }
      else
      {
        this.form.id=0;
        this.form.invoiceType=0;
        this.form.invoiceHeaderType=0;
        this.form.invoiceHeader='';
        this.form.dutyParagraph='';
        this.form.bankName='';
        this.form.bankCardNo='';
        this.form.companyAddress='';
        this.form.companyMobile='';
        this.form.isInvoiceDetails=false;
        switch(this.form.invoiceHeaderType)
        {
            case 0: this.invoiceHeaderType = '个人或者事业单位';break;
            case 1: this.invoiceHeaderType = '企业';break;
        }
      }
      this.dialogFormVisible = true;
    },     
    
    close() {    
      this.$refs['form'].resetFields()
      this.$emit('fetch-data')
      this.form = this.$options.data().form      
      this.dialogFormVisible = false
    },
    validateData()
    {         
      if(this.form.invoiceHeader==null||this.form.invoiceHeader==''||this.form.invoiceHeader==undefined)
      {
        this.$message.error('发票抬头不可为空!')
        return
      }
      if(this.invoiceHeaderType=="个人或者事业单位")
      {
        this.form.invoiceHeaderType=0;
      }
      else
      {
        this.form.invoiceHeaderType=1;
      }
      this.save();         
    },
    save() {    
      this.loading=true;
      this.elementLoadingText="数据提交中,请稍后..."
     
      var _this=this;
      this.$refs['form'].validate(async (valid) => {    
        if (valid) { 
          await createOrEdit(this.form).then(res=>{       
            _this.loading=false;   
            if(res&&res.data&&res.data.success==true)
            {
              _this.$confirm('保存成功！', '温馨提示',{type:'success'}).then(()=>
              {  
                 _this.$refs['form'].resetFields()
                 _this.$emit('fetch-data')
                 _this.dialogFormVisible = false     
                 _this.form = this.$options.data().form
              });   
            }    
            else
            {
               var msg='保存失败';
               if(res&&res.data&&res.data.error&&res.data.error.message)
               {
                  msg += ',原因:'+res.data.error.message;
               }
               this.$message({ message: msg, type: 'error', customClass: 'c-msg' })
            }
          })
        } else {
          _this.loading=false;
          return false
        }
      })
    },  
 
  },
}
</script>
<style>
.saveBtn
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
  color: #FFF !important;
  cursor: pointer !important;
}
.closeBtn
{
  border-color: #FF5E00 !important;
  color:#FF5E00 !important;
  cursor: pointer !important;
}
 .el-dialog__title
{
  font-size: 18px !important;
  color:#FF5E00 !important;
}
.el-radio__input.is-checked .el-radio__inner
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
}
.el-input .is-checked .el-checkbox__inner
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
}

.invoiceType
{
    width: 100%;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
}
.refundDescription
{
    width: 100%;
    height: 108px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    line-height: 1.5;
    outline: 0;
    padding: 3px 10px;
}

</style>


// WEBPACK FOOTER //
// EditInvoice.vue?7714d32b